import { useRef, useEffect } from 'react'
import { publishEvent } from '../../utils'
import PubSub from 'pubsub-js'
import { Button } from 'reactstrap'

export default function AppObjectOkButton(props) {
  console.log('AppObjectOkButton rendered', props)
  const { object, refListId } = props

  const okButtonRef = useRef(null)

  useEffect(() => {
    function handleEnableOkButtonEvent(msg, data) {
      console.log(`EVENT RECEIVED (AppObjectOkButton): ${msg}`, data)
      okButtonRef.current.disabled = false
    }
    const token = PubSub.subscribe(`ENABLE OK BUTTON ${object.id}`, handleEnableOkButtonEvent)
    return function cleanup() {
      PubSub.unsubscribe(token)
    }
  })

  function okButtonClicked(event) {
    console.log('AppObjectOkButton.okButtonClicked', event)
    okButtonRef.current.disabled = true
    if (refListId) {
      publishEvent(`CHILD OK BUTTON ${refListId}`, null, 'AppObjectOkButton.okButtonClicked')
    } else {
      publishEvent(`OK BUTTON ${object.id}`, null, 'AppObjectOkButton.okButtonClicked')
    }
  }

  return (
    <Button
      data-cy={`app-object-action-ok-button-${object.type.name.toLowerCase().replace(/ /g,'-')}`}
      color="primary"
      style={{ marginLeft: '20px' }}
      onClick={okButtonClicked}
      innerRef={okButtonRef}>Ok</Button>
  )
}